class CommercialTerms {
    constructor(
        amendmentProcessingMethod,
        collection,
        currentBalance,
        damageProcessingMethod,
        emissionProcessingMethod,
        inspectionProcessingMethod,
        quoteProcessingMethod
    ) {
        this.amendmentProcessingMethod = amendmentProcessingMethod
        this.collection = collection
        this.currentBalance = currentBalance
        this.damageProcessingMethod = damageProcessingMethod
        this.emissionProcessingMethod = emissionProcessingMethod
        this.inspectionProcessingMethod = inspectionProcessingMethod
        this.quoteProcessingMethod = quoteProcessingMethod
    }

    static fromJson({
        amendmentProcessingMethod,
        collection,
        currentBalance,
        damageProcessingMethod,
        emissionProcessingMethod,
        inspectionProcessingMethod,
        quoteProcessingMethod,
    }) {
        return new CommercialTerms(
            amendmentProcessingMethod,
            collection,
            currentBalance,
            damageProcessingMethod,
            emissionProcessingMethod,
            inspectionProcessingMethod,
            quoteProcessingMethod
        )
    }
}

export default CommercialTerms
